// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236B7280%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%234c2fb3%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Brand_pageWrap__pzRsz {
  padding: 4px 4px 32px;
}

.Brand_cardOuter__5j3TE {
  background: #ffffff;
  border: 1px solid #E7E9F1;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(27, 37, 89, 0.05);
  overflow: hidden;
  margin: 16px 0 0;
}

.Brand_headerBar__xzg7X {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 18px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.Brand_title__DYwZw {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #1F2430;
  letter-spacing: 0.01em;
}

.Brand_primaryBtn__pZ6Mg {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  border: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.02em;
  padding: 10px 22px;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 10px 22px -6px rgba(76, 47, 179, 0.45);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}
.Brand_primaryBtn__pZ6Mg:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 26px -6px rgba(76, 47, 179, 0.5);
  filter: brightness(1.04);
}
.Brand_primaryBtn__pZ6Mg:active { transform: translateY(0); }

.Brand_bodyArea__gzt39 {
  padding: 20px 26px 30px;
}

/* =========================================================
   Form — premium field / control system
   ========================================================= */
.Brand_field__J8CUA {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: 20px;
}

.Brand_label__9WdJz {
  font-size: 11.5px;
  font-weight: 700;
  color: #4B5563;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.Brand_required__o\\+1KO {
  color: #EF4444;
  margin-left: 3px;
}

.Brand_errorText__m3My1 {
  font-size: 11.5px;
  color: #EF4444;
  font-weight: 600;
  margin-top: -2px;
}

/* Error shown inline, on the same line as the field label */
.Brand_errorInline__z41sy {
  font-size: 11px;
  color: #EF4444;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
  margin-left: 8px;
}

.Brand_input__S4w7\\+ {
  height: 44px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #E3E6EC;
  font-size: 14px;
  color: #1F2430;
  background-color: #FCFCFD;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}
.Brand_input__S4w7\\+::placeholder { color: #9CA3AF; }
.Brand_input__S4w7\\+:hover { border-color: #CBD0DA; }
.Brand_input__S4w7\\+:focus {
  outline: none;
  border-color: #7c5cfc;
  background-color: #ffffff;
  box-shadow: 0 0 0 4px rgba(124, 92, 252, 0.14);
}

textarea.Brand_input__S4w7\\+ {
  height: auto;
  min-height: 96px;
  padding: 12px 14px;
  resize: vertical;
  line-height: 1.5;
}

select.Brand_input__S4w7\\+ {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 40px;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
}
select.Brand_input__S4w7\\+:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 14px center;
}

.Brand_fileInput__N05LB {
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px dashed #C9BCF2;
  background: #FAF8FF;
  font-size: 13px;
  color: #6B7280;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.Brand_fileInput__N05LB:hover {
  border-color: #7c5cfc;
  background: #F5F1FF;
}

.Brand_viewDocLink__wX8kd {
  font-size: 11.5px;
  margin-left: 8px;
  color: #4c2fb3;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.Brand_statusRow__PZfCD {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 44px;
  padding: 0 16px;
  border: 1px solid #E3E6EC;
  border-radius: 12px;
  background: #FCFCFD;
  font-size: 13px;
  font-weight: 600;
  color: #4B5563;
}

.Brand_checkbox__xFIw0 {
  width: 20px;
  height: 20px;
  accent-color: #4c2fb3;
  cursor: pointer;
}

.Brand_saveBtn__RwdjH {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  border: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 13.5px;
  letter-spacing: 0.02em;
  padding: 12px 34px;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 14px 26px -6px rgba(76, 47, 179, 0.45);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}
.Brand_saveBtn__RwdjH:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 32px -6px rgba(76, 47, 179, 0.52);
  filter: brightness(1.04);
}
.Brand_saveBtn__RwdjH:active { transform: translateY(0); }
.Brand_saveBtn__RwdjH:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
  filter: none;
}

.Brand_updateBtn__85fwi {
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
  border: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 13.5px;
  letter-spacing: 0.02em;
  padding: 12px 34px;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 14px 26px -6px rgba(22, 163, 74, 0.42);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}
.Brand_updateBtn__85fwi:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 32px -6px rgba(22, 163, 74, 0.5);
  filter: brightness(1.04);
}
.Brand_updateBtn__85fwi:active { transform: translateY(0); }
.Brand_updateBtn__85fwi:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
  filter: none;
}

/* =========================================================
   Table cells (Status badge / action icons)
   ========================================================= */
.Brand_statusBadgeActive__gU3Lg {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  background: #E9F9EF;
  color: #16A34A;
  font-size: 12px;
  font-weight: 700;
}

.Brand_imageThumb__5DC9G {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  object-fit: contain;
  border: 1px solid #E7E9F1;
  background: #FAFAFC;
  padding: 4px;
}

.Brand_noImageChip__Magpx {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  background: #F3F4F6;
  color: #9CA3AF;
  font-size: 11.5px;
  font-weight: 600;
  font-style: italic;
}

.Brand_statusBadgeInactive__jnew\\+ {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  background: #FDEDED;
  color: #DC2626;
  font-size: 12px;
  font-weight: 700;
}

.Brand_iconBtn__E5vtI {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;
}
.Brand_iconBtn__E5vtI:hover {
  background: #F1F2F6;
}

/* =========================================================
   Scoped overrides for the shared .custom-table (react-table),
   kept local to this page via :global so other pages using the
   same table component are unaffected.
   ========================================================= */
.Brand_tableWrap__-Yapv {
  overflow-x: auto;
}
.Brand_tableWrap__-Yapv .custom-table {
  box-shadow: none;
}
.Brand_tableWrap__-Yapv .custom-table thead {
  background: #F5F3FE;
}
.Brand_tableWrap__-Yapv .custom-table th {
  color: #4c2fb3;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 11.5px;
}
.Brand_tableWrap__-Yapv .custom-table tr:hover {
  background-color: #FAF8FF;
}
.Brand_tableWrap__-Yapv .custom-table tr:nth-child(even) {
  background-color: #ffffff;
}
.Brand_tableWrap__-Yapv .custom-table td {
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Brand/Brand.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oDAAoD;EACpD,0EAA0E;AAC5E;AACA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,wBAAwB;AAC1B;AACA,kCAAqB,wBAAwB,EAAE;;AAE/C;EACE,uBAAuB;AACzB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,uFAAuF;AACzF;AACA,oCAAsB,cAAc,EAAE;AACtC,6BAAe,qBAAqB,EAAE;AACtC;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,yDAA0Q;EAC1Q,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,yDAA0Q;EAC1Q,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oDAAoD;EACpD,0EAA0E;AAC5E;AACA;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,wBAAwB;AAC1B;AACA,+BAAkB,wBAAwB,EAAE;AAC5C;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oDAAoD;EACpD,0EAA0E;AAC5E;AACA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,wBAAwB;AAC1B;AACA,iCAAoB,wBAAwB,EAAE;AAC9C;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;;;;8DAI8D;AAC9D;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.cardOuter {\n  background: #ffffff;\n  border: 1px solid #E7E9F1;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(27, 37, 89, 0.05);\n  overflow: hidden;\n  margin: 16px 0 0;\n}\n\n.headerBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 18px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.title {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 17px;\n  font-weight: 700;\n  color: #1F2430;\n  letter-spacing: 0.01em;\n}\n\n.primaryBtn {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.02em;\n  padding: 10px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 10px 22px -6px rgba(76, 47, 179, 0.45);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n}\n.primaryBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 26px -6px rgba(76, 47, 179, 0.5);\n  filter: brightness(1.04);\n}\n.primaryBtn:active { transform: translateY(0); }\n\n.bodyArea {\n  padding: 20px 26px 30px;\n}\n\n/* =========================================================\n   Form — premium field / control system\n   ========================================================= */\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  margin-bottom: 20px;\n}\n\n.label {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #4B5563;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.required {\n  color: #EF4444;\n  margin-left: 3px;\n}\n\n.errorText {\n  font-size: 11.5px;\n  color: #EF4444;\n  font-weight: 600;\n  margin-top: -2px;\n}\n\n/* Error shown inline, on the same line as the field label */\n.errorInline {\n  font-size: 11px;\n  color: #EF4444;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: normal;\n  margin-left: 8px;\n}\n\n.input {\n  height: 44px;\n  padding: 0 14px;\n  border-radius: 12px;\n  border: 1px solid #E3E6EC;\n  font-size: 14px;\n  color: #1F2430;\n  background-color: #FCFCFD;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n.input::placeholder { color: #9CA3AF; }\n.input:hover { border-color: #CBD0DA; }\n.input:focus {\n  outline: none;\n  border-color: #7c5cfc;\n  background-color: #ffffff;\n  box-shadow: 0 0 0 4px rgba(124, 92, 252, 0.14);\n}\n\ntextarea.input {\n  height: auto;\n  min-height: 96px;\n  padding: 12px 14px;\n  resize: vertical;\n  line-height: 1.5;\n}\n\nselect.input {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 40px;\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n}\nselect.input:focus {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%234c2fb3' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n}\n\n.fileInput {\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1.5px dashed #C9BCF2;\n  background: #FAF8FF;\n  font-size: 13px;\n  color: #6B7280;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n.fileInput:hover {\n  border-color: #7c5cfc;\n  background: #F5F1FF;\n}\n\n.viewDocLink {\n  font-size: 11.5px;\n  margin-left: 8px;\n  color: #4c2fb3;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.statusRow {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  height: 44px;\n  padding: 0 16px;\n  border: 1px solid #E3E6EC;\n  border-radius: 12px;\n  background: #FCFCFD;\n  font-size: 13px;\n  font-weight: 600;\n  color: #4B5563;\n}\n\n.checkbox {\n  width: 20px;\n  height: 20px;\n  accent-color: #4c2fb3;\n  cursor: pointer;\n}\n\n.saveBtn {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 13.5px;\n  letter-spacing: 0.02em;\n  padding: 12px 34px;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 14px 26px -6px rgba(76, 47, 179, 0.45);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n}\n.saveBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 18px 32px -6px rgba(76, 47, 179, 0.52);\n  filter: brightness(1.04);\n}\n.saveBtn:active { transform: translateY(0); }\n.saveBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n  filter: none;\n}\n\n.updateBtn {\n  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 13.5px;\n  letter-spacing: 0.02em;\n  padding: 12px 34px;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 14px 26px -6px rgba(22, 163, 74, 0.42);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n}\n.updateBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 18px 32px -6px rgba(22, 163, 74, 0.5);\n  filter: brightness(1.04);\n}\n.updateBtn:active { transform: translateY(0); }\n.updateBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n  filter: none;\n}\n\n/* =========================================================\n   Table cells (Status badge / action icons)\n   ========================================================= */\n.statusBadgeActive {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  background: #E9F9EF;\n  color: #16A34A;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.imageThumb {\n  width: 42px;\n  height: 42px;\n  border-radius: 10px;\n  object-fit: contain;\n  border: 1px solid #E7E9F1;\n  background: #FAFAFC;\n  padding: 4px;\n}\n\n.noImageChip {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 20px;\n  background: #F3F4F6;\n  color: #9CA3AF;\n  font-size: 11.5px;\n  font-weight: 600;\n  font-style: italic;\n}\n\n.statusBadgeInactive {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  background: #FDEDED;\n  color: #DC2626;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.iconBtn {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.iconBtn:hover {\n  background: #F1F2F6;\n}\n\n/* =========================================================\n   Scoped overrides for the shared .custom-table (react-table),\n   kept local to this page via :global so other pages using the\n   same table component are unaffected.\n   ========================================================= */\n.tableWrap {\n  overflow-x: auto;\n}\n.tableWrap :global(.custom-table) {\n  box-shadow: none;\n}\n.tableWrap :global(.custom-table thead) {\n  background: #F5F3FE;\n}\n.tableWrap :global(.custom-table th) {\n  color: #4c2fb3;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 11.5px;\n}\n.tableWrap :global(.custom-table tr:hover) {\n  background-color: #FAF8FF;\n}\n.tableWrap :global(.custom-table tr:nth-child(even)) {\n  background-color: #ffffff;\n}\n.tableWrap :global(.custom-table td) {\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `Brand_pageWrap__pzRsz`,
	"cardOuter": `Brand_cardOuter__5j3TE`,
	"headerBar": `Brand_headerBar__xzg7X`,
	"title": `Brand_title__DYwZw`,
	"primaryBtn": `Brand_primaryBtn__pZ6Mg`,
	"bodyArea": `Brand_bodyArea__gzt39`,
	"field": `Brand_field__J8CUA`,
	"label": `Brand_label__9WdJz`,
	"required": `Brand_required__o+1KO`,
	"errorText": `Brand_errorText__m3My1`,
	"errorInline": `Brand_errorInline__z41sy`,
	"input": `Brand_input__S4w7+`,
	"fileInput": `Brand_fileInput__N05LB`,
	"viewDocLink": `Brand_viewDocLink__wX8kd`,
	"statusRow": `Brand_statusRow__PZfCD`,
	"checkbox": `Brand_checkbox__xFIw0`,
	"saveBtn": `Brand_saveBtn__RwdjH`,
	"updateBtn": `Brand_updateBtn__85fwi`,
	"statusBadgeActive": `Brand_statusBadgeActive__gU3Lg`,
	"imageThumb": `Brand_imageThumb__5DC9G`,
	"noImageChip": `Brand_noImageChip__Magpx`,
	"statusBadgeInactive": `Brand_statusBadgeInactive__jnew+`,
	"iconBtn": `Brand_iconBtn__E5vtI`,
	"tableWrap": `Brand_tableWrap__-Yapv`
};
export default ___CSS_LOADER_EXPORT___;
